import classNames from 'classnames';
import { connect } from 'react-redux';
import {
  API,
  AdCategoryHelper,
  ProgrammaticBuyerHelper,
  AdProviderHelper,
  Field2 as Field,
  SidePanelSection,
} from 'vibeguide';

function AdFields({
  className,
  style,
  deliverySystem = null,
  adProvider = null,
  advertiserName = null,
  category = null,
  agency = null,
  currencyCode = null,
  programmaticBuyer = null,
  onChange = () => {},
  onChangeDropdown = () => {},
  onChangeAdvertiser = () => {},
  user,
  currencies,
}) {
  return (
    <SidePanelSection
      className={classNames('AdFields', className)}
      style={style}
      title="Ad Information"
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
        }}
      >
        {deliverySystem !== null && (
          <Field
            type="dropdown"
            label="Delivery System"
            name="deliverySystem"
            value={deliverySystem}
            tabIndex={55}
            dropdownProps={{
              type: 'delivery system',
              attr: 'value',
              canCreate: user.can('flight_delivery_system.create'),
              successMessage: 'FLIGHTDELIVERYSYSTEM.CREATED',
              create: API.Flight.DeliverySystem.create,
              fetch: API.Flight.DeliverySystem.list,
            }}
            onChange={onChangeDropdown}
            required
          />
        )}

        {adProvider !== null && (
          <Field
            type="select"
            label="Ad Provider"
            name="adProvider"
            value={adProvider}
            options={[
              {
                label: '',
                value: '',
              },
              ...AdProviderHelper.list.map((adProvider) => {
                return {
                  label: adProvider.name,
                  value: adProvider.value,
                };
              }),
            ]}
            tabIndex={56}
            onChange={onChange}
            required
          />
        )}

        {advertiserName !== null && (
          <Field
            type="dropdown"
            label="Advertiser"
            name="advertiser"
            value={advertiserName}
            tabIndex={57}
            dropdownProps={{
              type: 'advertiser',
              attr: 'name',
              fetch: API.Advertiser.list,
              create: API.Advertiser.create,
              canCreate: user.can('advertiser.create'),
              successMessage: 'ADVERTISER.CREATED',
            }}
            onChange={onChangeAdvertiser}
            required
          />
        )}

        {category !== null && (
          <Field
            type="dropdown"
            label="Ad Category"
            name="category"
            value={category}
            dropdownProps={{
              type: 'category',
              attr: 'value',
              collection: AdCategoryHelper.list(),
            }}
            onChange={onChangeDropdown}
            tabIndex={58}
          />
        )}

        {agency !== null && (
          <Field
            type="text"
            label="Agency"
            name="agency"
            placeholder="Agency"
            value={agency}
            tabIndex={59}
            onChange={onChange}
          />
        )}

        {currencyCode !== null && (
          <Field
            type="select"
            label="Currency"
            name="currencyCode"
            value={currencyCode}
            options={[
              {
                label: '',
                value: '',
                placeholder: 'Choose a Currency...',
              },
              ...currencies.map(currency => {
                return {
                  label: currency.label,
                  value: currency.key,
                };
              }),
            ]}
            tabIndex={60}
            onChange={onChange}
            required
          />
        )}

        {programmaticBuyer !== null && (
          <Field
            type="select"
            label="Programmatic Buyer"
            name="programmaticBuyer"
            value={programmaticBuyer}
            options={ProgrammaticBuyerHelper.list({ includeEmpty: true })}
            tabIndex={61}
            onChange={onChange}
          />
        )}
      </div>
    </SidePanelSection>
  );
}

function mapStateToProps(state) {
  return {
    user: state.login.user,
    currencies: state.currency.list,
  };
}

export default connect(mapStateToProps)(AdFields);
